import { render, staticRenderFns } from "./SuperbillCodeAdmin.vue?vue&type=template&id=18a77f16"
import script from "./SuperbillCodeAdmin.vue?vue&type=script&lang=js"
export * from "./SuperbillCodeAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports